import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterService } from "../../../services/filter.service";
import { AuthService } from "../../../services/auth.service";
import { FilterRecordService } from "../../../services/filter-record.service";
import { PatientSearch } from "../../../model/patient/patient-search";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import { CenterFilter } from "../../../model/center-filter";
import { ServiceFilter } from "../../../model/service-filter";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import { StudyRegionFilter } from "src/app/model/study-report/study-region-filter";
import { MedicalServiceService } from "src/app/services/medical-service.service";

@Component({
  selector: "app-study-report-filter",
  templateUrl: "./study-report-filter.component.html",
  styleUrls: ["./study-report-filter.component.css"],
})
export class StudyReportFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteReferringPhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteStudyReportPhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;

  filterCompleteStudyRegions: FilterCompleteService<StudyRegionFilter>;

  seeAllStudies: boolean;
  myStudiesChecked: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private medicalServiceService: MedicalServiceService,
    private authService: AuthService,
    private studyReportService: StudyReportService,
    private filterRecordService: FilterRecordService
  ) {
    const date = new Date();
    const dateFrom = new Date(new Date(date).setDate(date.getDate() - 15));
    this.seeAllStudies = authService.seeAllStudies();
    this.myStudiesChecked = authService.myStudiesChecked();

    this.form = this.formBuilder.group({
      DateFrom: [dateFrom],
      DateTo: [new Date(new Date(dateFrom).setMonth(dateFrom.getMonth() + 1))],
      Patient: [null],
      ReferringPhysician: [null],
      StudyReportPhysician: [null],
      StudyRegion: [null],
      Center: [null],
      Service: [null],
      Protocol: [""],
      SeeToInform: [true],
      SeeToCorrect: [false],
      SeeConfirmed: [false],
      WithAdminControled: [false],
      ReAppointment: [false],
      AppointmentDate: [null],
      OrderByPatient: [false],
      MyStudyReport: [false],
    });

    this.filterCompleteServices = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompleteReferringPhysicians =
      new FilterCompleteService<PhysicianFilter>(
        [],
        this.form.controls.ReferringPhysician
      );
    this.filterCompleteStudyReportPhysicians =
      new FilterCompleteService<PhysicianFilter>(
        [],
        this.form.controls.StudyReportPhysician
      );
    this.filterCompleteCenters = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Center
    );
    this.filterCompleteStudyRegions =
      new FilterCompleteService<StudyRegionFilter>(
        [],
        this.form.controls.StudyRegion
      );
  }

  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "StudyReportFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "StudyReportFilterComponent",
      this.form
    );
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("DateFrom");
    requiredTags.push("DateTo");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  get filteredStudyRegionsOptions() {
    return this.filterCompleteStudyRegions
      ? this.filterCompleteStudyRegions.filteredOptions
      : [];
  }

  get filteredReferringPhysiciansOptions() {
    return this.filterCompleteReferringPhysicians
      ? this.filterCompleteReferringPhysicians.filteredOptions
      : [];
  }
  get filteredStudyReportPhysiciansOptions() {
    return this.filterCompleteStudyReportPhysicians
      ? this.filterCompleteStudyReportPhysicians.filteredOptions
      : [];
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }

  async search(): Promise<any> {
    let myStudyReport = true;
    if (this.seeAllStudies) {
      myStudyReport = this.form.controls.MyStudyReport.value
        ? <boolean>this.form.controls.MyStudyReport.value
        : false;
    }
    return await this.studyReportService.getStudyReportSearchItems(
      this.form.controls.Protocol.value,
      myStudyReport,
      this.form.controls.SeeToInform.value
        ? <boolean>this.form.controls.SeeToInform.value
        : false,
      this.form.controls.SeeToCorrect.value
        ? <boolean>this.form.controls.SeeToCorrect.value
        : false,
      this.form.controls.SeeConfirmed.value
        ? <boolean>this.form.controls.SeeConfirmed.value
        : false,
      true,
      this.form.controls.WithAdminControled.value
        ? <boolean>this.form.controls.WithAdminControled.value
        : false,
      this.form.controls.ReAppointment.value
        ? <boolean>this.form.controls.ReAppointment.value
        : false,
      Number(this.authService.getPhysicianId()),
      Number(this.authService.getStudyReportCircuitId()),
      this.form.controls.DateFrom.value
        ? this.form.controls.DateFrom.value
        : null,
      this.form.controls.DateTo.value ? this.form.controls.DateTo.value : null,
      this.form.controls.StudyReportPhysician.value
        ? (<PhysicianFilter>this.form.controls.StudyReportPhysician.value).Id
        : null,
      this.form.controls.ReferringPhysician.value
        ? (<PhysicianFilter>this.form.controls.ReferringPhysician.value).Id
        : null,
      this.form.controls.Patient.value
        ? (<PatientSearch>this.form.controls.Patient.value).Id
        : null,
      this.form.controls.Center.value
        ? (<CenterFilter>this.form.controls.Center.value).Id
        : null,
      this.form.controls.Service.value
        ? (<ServiceFilter>this.form.controls.Service.value).Id
        : null,
      this.form.controls.AppointmentDate.value
        ? this.form.controls.AppointmentDate.value
        : null,
      this.form.controls.OrderByPatient.value
        ? <boolean>this.form.controls.OrderByPatient.value
        : false,
      this.form.controls.StudyRegion.value
        ? this.form.controls.StudyRegion.value.Id
        : null
    );
  }

  ngOnInit(): void {
    if (
      this.myStudiesChecked &&
      !this.filterRecordService.existsFilters("StudyReportFilterComponent")
    ) {
      this.form.controls.MyStudyReport.setValue(true);
    }

    this.filterService.getPhysiciansFilter().then((physiciansFilter) => {
      this.filterCompleteReferringPhysicians =
        new FilterCompleteService<PhysicianFilter>(
          physiciansFilter,
          this.form.controls.ReferringPhysician
        );
      this.filterCompleteStudyReportPhysicians =
        new FilterCompleteService<PhysicianFilter>(
          physiciansFilter,
          this.form.controls.StudyReportPhysician
        );
    });
    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
        centers,
        this.form.controls.Center
      );
    });
    this.filterService.getServicesFilter().then((services) => {
      this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
        services,
        this.form.controls.Service
      );
    });

    this.medicalServiceService.getStudyRegionFilter().then((studyRegions) => {
      this.filterCompleteStudyRegions =
        new FilterCompleteService<StudyRegionFilter>(
          studyRegions,
          this.form.controls.StudyRegion
        );
    });
  }
}
